// hooks/usePermissionsEtatSalaires.js
// ============================================================================
// QUI VOIT, VALIDE ET DÉFIGE L'ÉTAT DES SALAIRES
// ============================================================================
//
// Trois permissions d'action, résolues par le rôle (16 septembre 2026) :
//
//   COMPTABILITE_ET_PAIE.ETAT_SALAIRES.VIEW     Comptable, Gestionnaire
//                                               pédagogique, Directeur Général,
//                                               Promoteur
//   COMPTABILITE_ET_PAIE.ETAT_SALAIRES.VALIDER  Comptable, Directeur Général
//   COMPTABILITE_ET_PAIE.ETAT_SALAIRES.DEFIGER  Directeur Général, Promoteur
//
// Le serveur tranche (backend2/routes/etatSalaires.routes.js) ; ce hook évite
// seulement de proposer ce qui serait refusé. ALL_MODULES les ouvre : la liste
// reçue du serveur l'a déjà développé.
// ============================================================================

import { usePermissions } from './usePermissions';

const CLES = {
  voir: 'COMPTABILITE_ET_PAIE.ETAT_SALAIRES.VIEW',
  valider: 'COMPTABILITE_ET_PAIE.ETAT_SALAIRES.VALIDER',
  defiger: 'COMPTABILITE_ET_PAIE.ETAT_SALAIRES.DEFIGER',
  // Ouverture exceptionnelle d'une étape du calendrier de paie (19/09/2026).
  ouvrir: 'COMPTABILITE_ET_PAIE.CALENDRIER.OUVRIR'
};

export const usePermissionsEtatSalaires = () => {
  const { detailedPermissions, loading } = usePermissions();
  const cles = new Set((detailedPermissions || []).map((p) => p.permission_key || p.key));

  return {
    peutVoir: cles.has(CLES.voir),
    peutValider: cles.has(CLES.valider),
    peutDefiger: cles.has(CLES.defiger),
    peutOuvrirCalendrier: cles.has(CLES.ouvrir),
    chargement: Boolean(loading)
  };
};

export default usePermissionsEtatSalaires;
